export default __webpack_public_path__ + "7d24d4d7bf282d7a49cf3e9582384e7b.babylon";